import React, { useState } from 'react';
import {
  Button,
  FormGroup,
  CustomInput,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';

export default function IsPremiumBuyerModal(props) {
  const { modal, handleClose, onSave } = props || {};
  const [isPremium, setIsPremiumState] = useState(false);

  const setIsPremium = (value) => {
    setIsPremiumState(value);
  };

  return (
    <Modal
      className="step-6-modal"
      centered
      isOpen={modal}
      toggle={handleClose}
    >
      <ModalHeader toggle={handleClose} className="pb-0 ml-4" tag="h1">
        Do these prices include Buyer&apos;s Premium?
      </ModalHeader>
      <ModalBody className="pt-0 mx-4 mb-4">
        <FormGroup
          className="mt-4"
          check
        >
          <div>
            <CustomInput
              onChange={() => setIsPremium(true)}
              type="radio"
              id="yes"
              name="customRadio"
              label="Yes"
              checked={isPremium}
            />
            <CustomInput
              onChange={() => setIsPremium(false)}
              type="radio"
              id="no"
              name="customRadio"
              label="No"
              checked={!isPremium}
            />
          </div>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
          className="min-width-max-content mr-3"
          color="primary"
          onClick={() => onSave(isPremium)}
        >
          Publish
        </Button>
        <Button color="link" onClick={handleClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
